import { render, staticRenderFns } from "./baseModal.vue?vue&type=template&id=5fff0e84&scoped=true"
import script from "./baseModal.vue?vue&type=script&lang=js"
export * from "./baseModal.vue?vue&type=script&lang=js"
import style0 from "./baseModal.vue?vue&type=style&index=0&id=5fff0e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fff0e84",
  null
  
)

export default component.exports